export enum AuthStorageKeys {
  ACCESS_TOKEN = 'accessToken',
  USER = 'user',
}
